import styled from "styled-components";

const StyledMemeberPayments = styled.div`
	width: 100%;
	max-width: 900px;

	.sb-member-payments-banner {
		width: 100%;
		padding: 16px;
		border-radius: 8px;
		background-color: #000;
		margin-top: 8px;
		.ant-typography {
			color: #fff;
			margin: 0;
		}
		.dot {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: red;
			&.active {
				background-color: #52c41a;
			}
		}
	}
	.sb-member-payments-selector {
		padding: 16px;
		background-color: #fafafa;
		font-size: 16px;
		margin-bottom: 16px;
		cursor: pointer;
	}
	.cancel {
		.primary-filled {
			background-color: var(--primary-color);
			border-color: var(--primary-color);
		}
		.primary-outlined {
			margin-top: 160px;
			border-color: var(--primary-color);
			.sb-button__inner {
				color: var(--primary-color);
			}
		}
	}
	.alert {
		padding: 12px;
		background: #ffd5cf;
	}

	.sb-member-payments {
		&__home-icon {
			height: 32px;
			width: 32px;
			margin-bottom: 40px;
			cursor: pointer;
		}

		&__header {
			&__image {
				max-width: 600px;
				max-height: 140px;
				margin-bottom: 60px;
			}

			&__title {
				margin-bottom: 16px;
			}

			&__subtitle {
				margin-bottom: 42px;
			}
		}

		&__payment-section {
			margin-top: 32px;

			&__payment-method {
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		&__dashboard {
			margin-top: 60px;
			width: 100%;
			text-align: center;
		}

		&__logout {
			margin-top: 16px;
			width: 100%;
			text-align: center;
		}
	}
`;

export default StyledMemeberPayments;

